import axios from '@/axios'

// Teaching systems

export async function getTeachingSystems () {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v1/intranet/teaching-systems')
  return response.data.data
}

export async function getTeachingSystemID (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v1/intranet/teaching-systems/' + id)
  return response.data.data
}

export async function newTeachingSystem (data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v1/intranet/teaching-systems/', data)
  return response.data.data
}

export async function updateTeachingSystem (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v1/intranet/teaching-systems/' + id, data)
  return response.data.data
}
export async function deleteTeachingSystem (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v1/intranet/teaching-systems/' + id)
  return response.data.data
}

export async function getGradeLevelGroupsOfTeachingSystem (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v1/intranet/teaching-systems/' + id + '/grade-level-groups')
  return response.data.data
}

export default {
  getTeachingSystems,
  getTeachingSystemID,
  newTeachingSystem,
  updateTeachingSystem,
  deleteTeachingSystem,
  getGradeLevelGroupsOfTeachingSystem
}
